/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title } = Typography;

const styles = {
  title: {
    color: '#404047',
    fontWeight: '700',
    fontSize: '24px',
    margin: 0,
    marginBottom: 8,
    lineHeight: '29px',
    textAlign: 'center'
  },
  subtitle: {
    color: '#8C8C8C',
    letterSpacing: '0.02em',
    fontSize: 14,
    textAlign: 'center',
    fontWeight: '300'
  },
  rowButton: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10
  },
}

function MobileHeaderBack({onBack, text, title, subtitle}) {
  return (
    <>
      <Row justify="center" style={{ padding: 0, marginBottom: 23 }}>
        <Col>
          <Button type="link" onClick={onBack}>
            <p style={styles.rowButton}>
              <ArrowLeftOutlined style={{ color: '#15A9E1' }} /> {text}
            </p>
          </Button>
        </Col>
      </Row>
      <Row justify="center" style={{ padding: 0, marginBottom: 28 }}>
        <Col>
          <Title level={4} style={styles.title}>
            {title}
          </Title>
          <p style={styles.subtitle}>
            {subtitle}
          </p>
        </Col>
      </Row>
    </>
  );
}

MobileHeaderBack.defaultProps = {
  onBack: () => null,
  text: '',
  title: '',
  subtitle: ''
};

const { func, string } = PropTypes;

MobileHeaderBack.propTypes = {
  onBack: func,
  text: string,
  title: string,
  subtitle: string
};

export default MobileHeaderBack;
